import { useTranslation } from "@/hooks/useTranslation";
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogScrollableArea,
	Icon,
	Typography,
} from "@st-marketplace/ui";

interface HelpCenterDialogProps {
	open: boolean;
	onClose: () => void;
}

const HelpCenterDialog: React.FC<HelpCenterDialogProps> = ({
	open,
	onClose,
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onOpenChange={(o) => !o && onClose()}>
			<DialogContent className="w-full">
				<DialogHeader>
					<div className="flex items-center">
						<Icon name="question-line" className="me-2 text-primary-fill" />
						<Typography variant="title-sm">
							{t("addSender.csv.helpTitle")}
						</Typography>
					</div>
				</DialogHeader>
				<DialogScrollableArea className="text-start max-h-screen">
					<div className="flex items-center gap-2 mb-2">
						<Icon name="file-excel-line" className="text-success-text" />
						<Typography variant="title-sm">
							{t("addSender.csv.helpUseCsvTitle")}
						</Typography>
					</div>

					<Typography
						variant="body-md"
						className="whitespace-pre-line text-secondary-text-100 border-b border-secondary-border pb-4 mb-3"
					>
						{t("addSender.csv.helpUseCsvDescription")}
					</Typography>

					<div className="flex items-center gap-2 mb-2">
						<Icon name="file-list-3-line" className="text-primary-icon" />
						<Typography variant="title-sm">
							{t("addSender.csv.helpUseFormTitle")}
						</Typography>
					</div>
					<Typography
						variant="body-md"
						className="whitespace-pre-line text-secondary-text-100 mb-5"
					>
						{t("addSender.csv.helpUseFormDescription")}
					</Typography>
				</DialogScrollableArea>
			</DialogContent>
		</Dialog>
	);
};

export default HelpCenterDialog;
